import React from "react";
import { Link } from "react-router-dom";
import './index.less'
export default function Footer(props) {
	return (
		<div className='proTitle'>
			<h3>{props.name}</h3>
			<div className="proTitle-text">{props.memo}</div>
		</div>
	);
}
